export class PaymentAntifraudeModel {
    name: string;
    value: number;
    dateTransaction: string;
    showAntifraude: boolean;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/models/payment-antifraude.model.ts